import { API_BASE_URL } from '../../config/api';
import apiCache, { CACHE_TTL } from '../../lib/apiCache';

const hijosKey = (email) => `hijos:${email}`;

const HijosData = {
    fetch: async (email) => {
        const key = hijosKey(email);
        const cached = apiCache.get(key);
        if (cached !== undefined) return cached;

        try {
            const response = await fetch(`${API_BASE_URL}/api/profile?email=${email}`);
            const data = await response.json();
            const hijosArray = data.Hijos || [];
            
            // Map through all children entries
            const result = hijosArray.map(hijosData => ({
                padcodigo: hijosData.padcodigo,
                hicodigo: hijosData.hicodigo,
                hijugador: hijosData.hijugador,
                nombre: hijosData.hinombre,
                apellidoPaterno: hijosData.hiappaterno,
                apellidoMaterno: hijosData.hiapmaterno,
                club: hijosData.clubcodigo,
                rama: hijosData.hisexo,
                fnacimiento: hijosData.hifnacimiento,
                asociado: hijosData.hirepresenta,
                curp: hijosData.hicurp,
            }));
            return apiCache.set(key, result, CACHE_TTL.USER);
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    },

    update: async (hijoData) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/hijo/update`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    padcodigo: hijoData.padcodigo,
                    hicodigo: hijoData.hicodigo,
                    nombre: hijoData.nombre,
                    apellidoPaterno: hijoData.apellidoPaterno,
                    apellidoMaterno: hijoData.apellidoMaterno,
                    club: hijoData.club,
                    rama: hijoData.rama,
                    fnacimiento: hijoData.fnacimiento,
                    asociado: hijoData.asociado,
                    curp: hijoData.curp
                })
            });

            let data;
            try {
                data = await response.json();
            } catch (e) {
                console.error('Failed to parse server response:', e);
                throw new Error('Invalid server response');
            }

            if (!response.ok) {
                throw new Error(data.message || 'Error updating hijo');
            }

            apiCache.invalidate('hijos:');
            return data;
        } catch (error) {
            console.error('Error updating hijo:', error);
            throw error;
        }
    },

    create: async (hijoData) => {
        try {
            // Log the exact data being sent
            console.log('Creating hijo with data:', hijoData);
            
            const requestBody = {
                padcodigo: hijoData.padcodigo,
                nombre: hijoData.nombre,
                apellidoPaterno: hijoData.apellidoPaterno,
                apellidoMaterno: hijoData.apellidoMaterno,
                club: hijoData.club,
                rama: hijoData.rama,
                fnacimiento: hijoData.fnacimiento,
                curp: hijoData.curp,
                hiinstagram: hijoData.hiinstagram || '@instagram',
                hifacebook: hijoData.hifacebook || 'facebook.facebook'
            };

            console.log('Request body:', requestBody);

            const response = await fetch(`${API_BASE_URL}/api/hijo/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            // Log the response status and headers
            console.log('Server response status:', response.status);
            console.log('Server response headers:', Object.fromEntries(response.headers.entries()));

            let data;
            try {
                data = await response.json();
                console.log('Server response data:', data);
            } catch (e) {
                console.error('Failed to parse server response:', e);
                throw new Error('Invalid server response');
            }

            if (!response.ok) {
                throw new Error(data.message || 'Error creating hijo');
            }

            apiCache.invalidate('hijos:');
            return data;
        } catch (error) {
            console.error('Error creating hijo:', error);
            throw error;
        }
    },

    delete: async (hijoData) => {
        try {
            console.log('Deleting hijo with data:', hijoData);
            
            const response = await fetch(`${API_BASE_URL}/api/hijo/delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    padcodigo: hijoData.padcodigo,
                    hicodigo: hijoData.hicodigo
                })
            });

            let data;
            try {
                data = await response.json();
                console.log('Delete response:', data);
            } catch (e) {
                console.error('Failed to parse server response:', e);
                throw new Error('Invalid server response');
            }

            if (!response.ok) {
                throw new Error(data.message || 'Error deleting hijo');
            }

            apiCache.invalidate('hijos:');
            return data;
        } catch (error) {
            console.error('Error deleting hijo:', error);
            throw error;
        }
    }
};

export default HijosData;